// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"388":"61049e4e","800":"af633bfc"}[chunkId] + ".chunk.css";
};